import { IApplicationState } from '../types/redux';

export const selectAnonymousUserId = (state: IApplicationState) => state.user.anonymousUserId;
